<template>
  <div class="home-v2">
    <div class="level1-container">
      <div class="level1-top">
        <!-- Start Left Level 1 -->
        <div class="level1-left">
          <div class="filter">
            <div class="filter__title">
              FILTER <i class="fa fa-refresh" @click="resetFilter()"></i>
            </div>
            <div class="filter-list">
              <!-- Start Left Filter -->
              <div class="filter-list__list">
                <div class="list-wrapper">
                  <div class="title">Periode</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="3" v-model="choosePeriode" />3 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="6" v-model="choosePeriode" />6 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="12" v-model="choosePeriode" />12 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="24" v-model="choosePeriode" />24 Bulan
                    </div>
                  </div>
                </div>
                <!-- <div class="list-wrapper">
                  <div class="title">Periode Event</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input
                        type="radio"
                        class="input-filter"
                        value="3"
                        v-model="choosePeriodeEvent"
                      />3 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input
                        type="radio"
                        class="input-filter"
                        value="6"
                        v-model="choosePeriodeEvent"
                      />6 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input
                        type="radio"
                        class="input-filter"
                        value="12"
                        v-model="choosePeriodeEvent"
                      />12 Bulan
                    </div>
                    <div class="list-detail-input">
                      <input
                        type="radio"
                        class="input-filter"
                        value="24"
                        v-model="choosePeriodeEvent"
                      />24 Bulan
                    </div>
                  </div>
                </div> -->

                <div class="list-wrapper">
                  <div class="title">SIO</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="1" v-model="chooseSio" />Active
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="0" v-model="chooseSio" />Non Active
                    </div>
                  </div>
                </div>

                <div class="list-wrapper">
                  <div class="title">Negara</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="63" v-model="choosedCountry" />Indonesia
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="5" v-model="choosedCountry" />United State
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="104" v-model="choosedCountry" />Malaysia
                    </div>
                  </div>
                </div>
                <div class="list-wrapper">
                  <div class="title">Provinsi</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="15" v-model="choosedProvince" />Kalimantan Timur
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="13" v-model="choosedProvince" />Kalimantan Selatan
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="6" v-model="choosedProvince" />DKI Jakarta
                    </div>
                  </div>
                </div>
                <div class="list-wrapper">
                  <div class="title">Kota</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="57" v-model="choosedCity" />Jakarta
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="221" v-model="choosedCity" />Berau
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="196" v-model="choosedCity" />Banjarmasin
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Left Filter -->

              <!-- Start Right Filter -->
              <div class="filter-list__list">
                <div class="list-wrapper">
                  <div class="title">Sub Kategori</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <span class="detail-icon" @click="kbliFilterDetail()">Detail <i
                          class="fas fa-chevron-right"></i></span>
                    </div>
                  </div>
                </div>

                <div class="list-wrapper">
                  <div class="title">Pertambangan</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="1" v-model="chooseMine" />Inti
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="0" v-model="chooseMine" />Non Inti
                    </div>
                  </div>
                </div>
                <div class="list-wrapper">
                  <div class="title">Praqualifikasi</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="checkbox" class="input-filter" value="k3l" v-model="choosePraqualifikasiK3l" />K3L
                    </div>
                    <div class="list-detail-input">
                      <input type="checkbox" class="input-filter" value="kplh" v-model="choosePraqualifikasiKplh" />KPLH
                    </div>
                  </div>
                </div>

                <div class="list-wrapper" v-if="k3lCriteria && choosePraqualifikasiK3l">
                  <div class="title">Nilai K3L</div>
                  <div class="list-detail">
                    <div class="list-detail-input" v-for="(list, index) in k3lCategories" :key="index">
                      <input type="checkbox" class="input-filter" :value="list.id" v-model="chooseK3lScore" />
                      <label class="label-filter">{{ list.desc }}</label>
                    </div>
                  </div>
                </div>

                <div class="list-wrapper" v-if="kplhCriteria && choosePraqualifikasiKplh">
                  <div class="title">Nilai KPLH</div>
                  <div class="list-detail">
                    <div class="list-detail-input" v-for="(list, index) in kplhCategories" :key="index">
                      <input type="checkbox" class="input-filter" :value="list.id" v-model="chooseKplhScore" />
                      <label class="label-filter">{{ list.desc }}</label>
                    </div>
                  </div>
                </div>

                <div class="list-wrapper">
                  <div class="title">Status</div>
                  <div class="list-detail">
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="1" v-model="chooseStatus" />Active
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="2" v-model="chooseStatus" />Block
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="3" v-model="chooseStatus" />Active Only
                    </div>
                    <div class="list-detail-input">
                      <input type="radio" class="input-filter" value="4" v-model="chooseStatus" />Block Only
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Right Filter -->
            </div>
          </div>
        </div>
        <!-- End Left Level 1 -->

        <!-- Start Right Level 1 -->
        <div class="level1-right">
          <div class="level1-right__menus">
            <div class="menu-list">
              <div style="color:#cc3333; fontWeight: bold">URUTKAN</div>
              <div class="po-tooltips">
                <div class="hover-red" @click="poTerbanyak()">PO TERBANYAK</div>
              </div>
              <div class="hover-red" @click="eventTerbanyak()">
                EVENT TERBANYAK
              </div>
              <div class="hover-red" @click="level1Terbaru()">TERBARU</div>
            </div>
            <div class="status-category">
              Kategori: {{ $store.state.level1.statusCategory }}
            </div>
            <div class="search-and-rows">
              <div>Total Data:</div>
              <div class="search-and-rows__row-setting">
                <b-form-select v-model="perPage" :options="modes" class="total-rows"></b-form-select>
              </div>
              <!-- <div class="search-and-rows__search">
                <input type="text" placeholder="Search From The List" />
                <div><strong class="text-danger"><i class="fas fa-search"></i></strong></div>
              </div> -->
            </div>
          </div>
          <div class="level1-right__list" v-if="$store.state.level1.dataLevel1">
            <div class="list-card" v-for="(list, index) in $store.state.level1.dataLevel1" :key="index"
              @click="showModal(list.id)">
              <div class="list-card__logo">
                <div class="circle">
                  <img :src="`${api}/file/${list.logo}`" alt="" v-if="list && list.logo" />
                  <div :class="checkTotalInitial(list.nama_vendor) < 3
                    ? 'initial'
                    : `initial${checkTotalInitial(list.nama_vendor)}`
                    " v-else>
                    {{ generateInitial(list.nama_vendor) }}
                  </div>
                </div>
              </div>
              <div class="list-card__detail">
                <div class="detail-header">
                  <div class="detail-header__title">{{ list.nama_vendor }}</div>
                  <div class="detail-header__sub-title">
                    {{ list.alias_profile }} - {{ afiliationClass(list) }}
                  </div>
                  <div class="detail-header__sub-title">{{ list.city }}</div>
                </div>
                <div class="server-list">
                  <!-- <div :class="server" v-for="(server, index) in list.server" :key="index">
                    <div v-if="server !== 'SAP'">{{ server }}</div>
                    <img class="sap-logo" src="../../../assets/img/SAP.png" alt="" v-if="server === 'SAP'">
                  </div> -->
                  <div class="SAP" v-if="list.isupplier_code">
                    <img class="sap-logo" src="../../../assets/img/SAP.png" alt="" />
                  </div>
                  <div class="ARIBA" v-if="list.ariba_code">
                    <div>ARIBA</div>
                  </div>
                  <div class="BCE" v-if="list.bce_code">
                    <div>BCE</div>
                  </div>
                  <div class="GEMS" v-if="list.gems_code">
                    <div>GEMS</div>
                  </div>
                  <div class="BKES" v-if="list.bkes_code && list.bkes_code !== '0'">
                    <div>BKES</div>
                  </div>
                </div>
                <div class="rating-wrapper">
                  <div>
                    <span :class="kinerjaPoRating(list.csi_score_avg, 1)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaPoRating(list.csi_score_avg, 2)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaPoRating(list.csi_score_avg, 3)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaPoRating(list.csi_score_avg, 4)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaPoRating(list.csi_score_avg, 5)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                  </div>
                  <div class="rating-wrapper__name">Kinerja PO</div>
                </div>
                <div class="rating-wrapper">
                  <div>
                    <span :class="kinerjaKontrakRating($get(list, 'grade', 0), 1)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaKontrakRating($get(list, 'grade', 0), 2)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaKontrakRating($get(list, 'grade', 0), 3)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaKontrakRating($get(list, 'grade', 0), 4)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                    <span :class="kinerjaKontrakRating($get(list, 'grade', 0), 5)
                      ? 'star-active'
                      : 'star-deactive'
                      ">&#9733;</span>
                  </div>
                  <div class="rating-wrapper__name">Kinerja Kontrak</div>
                </div>
                <div class="score-container">
                  <div class="score-wrapper">
                    <div class="score-wrapper__title">K3L Score</div>
                    <div class="score-wrapper__value"
                      :style="{ color: isK3lExpired(list.latest_tanggal_berakhir_k3l) ? 'red' : '' }">
                      - {{ $get(list, 'latest_k3l', 0) }}
                      {{ getK3lCategories(list.latest_k3l) }}
                    </div>
                  </div>
                  <div class="score-wrapper">
                    <div class="score-wrapper__title">KPLH Score</div>
                    <div class="score-wrapper__value"
                      :style="{ color: isKplhExpired(list.latest_tanggal_berakhir_kplh) ? 'red' : '' }">
                      - {{ $get(list, 'latest_kplh', 0) }}
                      {{
                        $get(list, 'keterangan_kplh', '') ==
                          'TIDAK LULUS PRAQUALIFIKASI'
                          ? 'TIDAK LULUS'
                          : $get(list, 'latest_resiko', '')
                      }}
                    </div>
                    <!-- <div class="score-wrapper__value">
                      - {{ $get(list, 'latest_kplh', 0) }}
                      {{ getKplhCategories(list.latest_kplh) }}
                    </div> -->
                  </div>
                  <div class="score-wrapper">
                    <div class="score-wrapper__title">Total Event</div>
                    <div class="score-wrapper__value">
                      - {{ list.total_event }} Event
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="level1-right__pagination">
            <div class="mlp-pagination-wrapper-level1">
              <b-pagination aria-controls="isupplier-table" v-model="currentPage" :total-rows="totalItems"
                :per-page="perPage" align="fill" class="mlp-pagination" hide-goto-end-buttons
                :limit="10"></b-pagination>
            </div>
          </div>
        </div>
        <!-- End Right Level 1 -->
      </div>
    </div>
    <transition name="fade">
      <div class="modal-level2-container" v-show="$store.state.modalStore.showModalLevel1">
        <div class="modal-level2-dialog">
          <div class="modal-level2-content">
            <div class="modal-level2-body">
              <div class="modal-button-close">
                <i class="far fa-times-circle" @click="closeModal()"></i>
              </div>
              <Level2 />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <NewVendor v-show="$store.state.modalStore.showNewVendor" />
    <KbliModalFilter v-if="$store.state.searchStore.modalKbliFilter" />
    <ModalExtendSap v-if="$store.state.modalReqApp.modalExtendSap" />
    <ModalBlockVendor v-if="$store.state.modalReqApp.modalBlockVendor" />
    <ModalUnblockVendor v-if="$store.state.modalReqApp.modalUnblockVendor" />
    <DeleteVendor v-if="$store.state.modalReqApp.modalDeleteVendor" />
    <LegalDoc v-if="$store.state.modalStore.showLegalDoc" />
    <Praqualifikasi v-if="$store.state.modalReqApp.modalPraqualifikasiLevel2" />
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  name: 'level1',
  components: {
    Level2: () => import('@/views/V2/Level2.vue'),
    NewVendor: () => import('@/components/modal/newVendor.vue'),
    KbliModalFilter: () => import('@/components/modal/KbliModalFilter.vue'),

    ModalExtendSap: () => import('@/components/modal/ExtendSap.vue'),
    ModalBlockVendor: () => import('@/components/modal/BlockVendor.vue'),
    ModalUnblockVendor: () => import('@/components/modal/UnblockVendor.vue'),
    DeleteVendor: () => import('@/components/modal/DeleteVendor.vue'),
    Praqualifikasi: () =>
      import('@/components/modal/praqualifikasi/Praqualifikasi-level2.vue'),

    LegalDoc: () => import('@/components/modal/legalDocument.vue'),
  },
  data() {
    return {
      api: api,
      isModalVisible: false,
      modes: [5, 10, 15, 20, 25],
      k3lCategories: null,
      kplhCategories: null,

      listData: [
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'RIFKY KURNIAWAN',
          type: 'Perorangan',
          affiliate: false,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
      ],
      leftFilters: [
        {
          title: 'Periode PO',
          type: 'radio',
          filters: [
            {
              name: '6 Bulan',
              value: '6',
            },
            {
              name: '12 Bulan',
              value: '12',
            },
            {
              name: '24 Bulan',
              value: '24',
            },
          ],
        },
        {
          title: 'Periode Event',
          type: 'radio',
          filters: [
            {
              name: '6 Bulan',
              value: '6',
            },
            {
              name: '12 Bulan',
              value: '12',
            },
            {
              name: '24 Bulan',
              value: '24',
            },
          ],
        },
      ],
      sub: [
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
      ],
    }
  },
  computed: {
    totalItems() {
      let items = this.$store.state.level1.totalItems
      let maxTotal = Number(this.perPage) * 20
      return items > maxTotal ? maxTotal : items
      // return items
    },
    perPage: {
      get: function () {
        return this.$store.state.level1.perPage
      },
      set: function (newValue) {
        this.$store.dispatch('level1/setLevel1PerPage', newValue)
      },
    },
    currentPage: {
      get: function () {
        return this.$store.state.level1.page
      },
      set: async function (newValue) {
        await this.$store.dispatch('level1/setLevel1Page', newValue)
        await this.$store.commit('level1/SET_DATA_LEVEL1', { notReset: true })
      },
    },
    k3lCriteria: async function () {
      return this.getK3lCriteria()
    },
    kplhCriteria: async function () {
      return this.getKplhCriteria()
    },
    choosedCountry: {
      get: function () {
        return this.$store.state.searchStore.choosedCountry
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedCountry',
          value: newValue,
        })

        let query = {
          negara: `&negara_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosedProvince: {
      get: function () {
        return this.$store.state.searchStore.choosedProvince
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedProvince',
          value: newValue,
        })

        let query = {
          prov: `&provinsi_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosedCity: {
      get: function () {
        return this.$store.state.searchStore.choosedCity
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedCity',
          value: newValue,
        })

        let query = {
          kota: `&kota_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePeriode: {
      get: function () {
        return this.$store.state.searchStore.choosePeriode
      },
      set: async function (newValue) {
        const start = this.monthFromNow(newValue)
        const end = this.$now()

        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriode',
          value: newValue,
        })

        // START DATE
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoStart',
          value: start,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoStart',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventStartDate',
          value: start,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmStartDate',
          value: start,
        })

        // END DATE
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customDetailPoEnd',
          value: end,
        })
        this.$store.commit('level1/SET_CUSTOM_DATE', {
          name: 'customKinerjaPoEnd',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'kinerjaPoEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventEndDate',
          value: end,
        })
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'spmEndDate',
          value: end,
        })

        let query = {
          poStart: `&po_start_date=${start}`,
          poEnd: `&po_end_date=${end}`,
          eventStart: `&event_start_date=${start}`,
          eventEnd: `&event_end_date=${end}`,
          spmStart: `&spm_start_date=${start}`,
          spmEnd: `&spm_end_date=${end}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePeriodeEvent: {
      get: function () {
        return this.$store.state.searchStore.choosePeriodeEvent
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodeEvent',
          value: newValue,
        })

        let query = {
          eventStart: `&event_start_date=${this.monthFromNow(newValue)}`,
          eventEnd: `&event_end_date=${this.$now()}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseK3lScore: {
      get: function () {
        return this.$store.state.searchStore.chooseK3lScore
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseK3lScore',
          value: newValue,
        })

        let query = {
          k3lScore:
            newValue.length > 0
              ? this.paramsFormatter('k3l_score', newValue)
              : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseKplhScore: {
      get: function () {
        return this.$store.state.searchStore.chooseKplhScore
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseKplhScore',
          value: newValue,
        })

        let query = {
          kplhScore:
            newValue.length > 0
              ? this.paramsFormatter('kplh_score', newValue)
              : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseMine: {
      get: function () {
        return this.$store.state.searchStore.chooseMine
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: newValue,
        })

        let query = {
          tambang: `&pertambangan_inti=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseSio: {
      get: function () {
        return this.$store.state.searchStore.chooseSio
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseSio',
          value: newValue,
        })

        let query = {
          sio: `&sio=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseStatus: {
      get: function () {
        return this.$store.state.searchStore.chooseStatus
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseStatus',
          value: newValue,
        })

        let query = {
          sio: `&status=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePraqualifikasiK3l: {
      get: function () {
        return this.$store.state.searchStore.choosePraqualifikasiK3l
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiK3l',
          value: newValue,
        })

        let query = {
          k3l: newValue ? '&k3l=1' : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePraqualifikasiKplh: {
      get: function () {
        return this.$store.state.searchStore.choosePraqualifikasiKplh
      },
      set: async function (newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiKplh',
          value: newValue,
        })

        let query = {
          kplh: newValue ? '&kplh=1' : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
  },
  methods: {
    isKplhExpired(data) {
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      return expirationDate < today;
    },
    isK3lExpired(data) {
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      return expirationDate < today;
    },
    kbliFilterDetail() {
      this.$store.commit('searchStore/SET_OTHER_MODAL', {
        name: 'modalKbliFilter',
        status: true,
      })
    },
    async resetFilter() {
      await this.$store.commit('level1/SET_STATUS_CATEGORY')
      await this.$store.commit('searchStore/RESET_FILTER')
      await this.$store.commit('level1/RESET_QUERY')

      await this.$store.commit('level1/SET_DATA_LEVEL1')
    },
    async showModal(id) {
      await this.$store.commit('modalStore/SET_MODAL_LEVEL1', true)
      await this.$store.commit('level1/GET_PROFILE_DATA', { id })
    },
    closeModal() {
      this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
    },
    k3lRiskCategory(score) {
      if (score && score > 0) {
        if (score <= 24) return 'LOW C2'
        if (score > 24 && score < 35) return 'LOW C1'
        if (score >= 35 && score < 50) return 'MEDIUM B2'
        if (score >= 50 && score < 70) return 'MEDIUM B1'
        if (score >= 70 && score <= 100) return 'HIGH'
      }
      return '-'
    },
    poTerbanyak() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=total_po&order_short=desc'
      )
    },
    eventTerbanyak() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=total_event&order_short=desc'
      )
    },
    level1Terbaru() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=createdAt&order_short=desc'
      )
    },
    async getK3lCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=5`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        this.k3lCategories = k3l.data

        if (this.k3lCategories) {
          return true
        }

        return false
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getKplhCriteria() {
      try {
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=4`

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        this.kplhCategories = kplh.data

        if (this.kplhCategories) {
          return true
        }

        return false
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    getK3lCategories(value) {
      const categories = this.k3lCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
    getKplhCategories(value) {
      const categories = this.kplhCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
  },
}
</script>
